/**
 * Direct deep-link screen for Raise Package generation.
 */
import { bindRaisePackage, raisePackageFormHtml } from "./dashboard-raise-package.js";
import { pipelineOperatorNavHtml } from "./dashboard-pipeline-nav.js";

export function raisePackageRequested(): boolean {
  const value = new URLSearchParams(window.location.search).get("raise_package")?.trim().toLowerCase() ?? "";
  return value === "1" || value === "true";
}

export async function renderDirectRaisePackage(
  mount: HTMLElement,
  onAuthRequired: (message: string) => void
): Promise<void> {
  mount.innerHTML = `
    <main class="dashboard-shell raise-package-direct sp-lookup-direct" data-raise-package-direct>
      ${pipelineOperatorNavHtml("raise")}
      <section class="sp-lookup-hero raise-package-hero">
        <div>
          <p class="eyebrow">County Preforeclosure Pipeline</p>
          <h1>Raise Package</h1>
          <p>Search a property lead, fill investor and return terms, and download an Investment Memorandum, Promissory Note, and Wire Transfer Instructions.</p>
        </div>
      </section>
      ${raisePackageFormHtml()}
    </main>
  `;
  bindRaisePackage({ onAuthRequired });
}
